import httpClient from "../../utilities/http-client";
import {
	IdentityOperationResponse,
	RoleResponse,
	UsersWithRolesResponse,
} from "../../models/identity/IdentityManagement";

export const getRoles = async (): Promise<RoleResponse[]> => {
	try {
		const { data } = await httpClient.get<RoleResponse[]>(`/identity-management/roles`);
		return data;
	} catch (e: any) {
		throw e.response || e;
	}
};

export const createRole = async (name: string): Promise<IdentityOperationResponse> => {
	try {
		const { data } = await httpClient.post<IdentityOperationResponse>(`/identity-management/roles`, { name });
		return data;
	} catch (e: any) {
		throw e.response?.data || e.response || e;
	}
};

export const deleteRole = async (roleId: string): Promise<IdentityOperationResponse> => {
	try {
		const { data } = await httpClient.delete<IdentityOperationResponse>(`/identity-management/roles/${encodeURIComponent(roleId)}`);
		return data;
	} catch (e: any) {
		throw e.response?.data || e.response || e;
	}
};

export const getIdentityUsers = async (search: string, from: number, count: number): Promise<UsersWithRolesResponse> => {
	try {
		const params = new URLSearchParams();
		params.append("from", from.toString());
		params.append("count", count.toString());
		if (search) params.append("search", search);

		const { data } = await httpClient.get<UsersWithRolesResponse>(`/identity-management/users?${params.toString()}`);
		return data;
	} catch (e: any) {
		throw e.response || e;
	}
};

export const getUserRoles = async (userId: string): Promise<string[]> => {
	try {
		const { data } = await httpClient.get<string[]>(`/identity-management/users/${encodeURIComponent(userId)}/roles`);
		return data;
	} catch (e: any) {
		throw e.response || e;
	}
};

export const assignRole = async (userId: string, roleName: string): Promise<IdentityOperationResponse> => {
	try {
		const { data } = await httpClient.post<IdentityOperationResponse>(`/identity-management/users/roles`, { userId, roleName });
		return data;
	} catch (e: any) {
		throw e.response?.data || e.response || e;
	}
};

export const removeRole = async (userId: string, roleName: string): Promise<IdentityOperationResponse> => {
	try {
		const { data } = await httpClient.post<IdentityOperationResponse>(`/identity-management/users/roles/remove`, { userId, roleName });
		return data;
	} catch (e: any) {
		throw e.response?.data || e.response || e;
	}
};
